import { faArrowRight, faCalendarDay } from '@fortawesome/pro-regular-svg-icons'
import {
  ActionIcon,
  Box,
  type BoxProps,
  Button,
  Flex,
  Menu,
  Title,
} from '@mantine/core'
import { useClickOutside } from '@mantine/hooks'
import { useEffect, useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon, TextDate, useMediaQuery } from '@flecto/ui'

import { useStoreDates } from '../../hooks/useStoreDates'
import { SectionDatesSelector } from '../SectionDatesSelector/SectionDatesSelector'
import styles from './styles.module.css'

export function DropdownSelectDates(props: BoxProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })

  const ref = useClickOutside(() => setDatesOpened(false))

  const { isDesktop } = useMediaQuery()
  const { opened, setDatesOpened, startAt, endAt, setStartAt, setEndAt } =
    useStoreDates()

  const [localStartAt, setLocalStartAt] = useState(startAt ?? '')
  const [localEndAt, setLocalEndAt] = useState(endAt ?? '')

  const handleConfirmDates = () => {
    setStartAt(localStartAt)
    setEndAt(localEndAt)
    setDatesOpened(false)
  }

  useEffect(() => {
    if (startAt) {
      setLocalStartAt(startAt ?? '')
    }

    if (endAt) {
      setLocalEndAt(endAt ?? '')
    }
  }, [startAt, endAt])

  return (
    <Menu opened={opened} withinPortal shadow='md'>
      <Menu.Target>
        {isDesktop ? (
          <Button
            variant='light'
            color='gray'
            size={isDesktop ? 'md' : 'sm'}
            className={props.className}
            onClick={() => setDatesOpened(true)}
          >
            {startAt && endAt ? (
              <Flex align='center' gap='sm'>
                <TextDate date={startAt} />
                <Icon icon={faArrowRight} size='xs' color='gray.5' />
                <TextDate date={endAt} />
              </Flex>
            ) : (
              t('dropdown_select_dates.label_target')
            )}
          </Button>
        ) : (
          <ActionIcon
            variant='light'
            color='gray'
            size='sm'
            onClick={() => setDatesOpened(true)}
          >
            <Icon icon={faCalendarDay} />
          </ActionIcon>
        )}
      </Menu.Target>
      <Menu.Dropdown className={styles.dropdown} ref={ref}>
        <Box className={styles.content}>
          <Title order={5} mb='md'>
            {t('dropdown_select_dates.title')}
          </Title>
          <SectionDatesSelector
            startAt={localStartAt}
            endAt={localEndAt}
            onChangeEndAt={setLocalEndAt}
            onChangeStartAt={setLocalStartAt}
          />
        </Box>
        <Box className={styles.footer}>
          <Button
            fullWidth
            disabled={!localStartAt || !localEndAt}
            onClick={handleConfirmDates}
          >
            {t('dropdown_select_dates.label_button')}
          </Button>
          {!isDesktop && (
            <Button
              fullWidth
              mt='sm'
              h={30}
              variant='white'
              onClick={() => setDatesOpened(false)}
            >
              {t('dropdown_select_dates.link_close')}
            </Button>
          )}
        </Box>
      </Menu.Dropdown>
    </Menu>
  )
}
